import { SelectOption } from './types'
import { Resolution } from './useResolutionData'

export const resolutionToOption = () => (
  resolution: Resolution
): SelectOption => ({
  value: resolution.code,
  label: resolution.description,
})
